import { render, staticRenderFns } from "./HistoryDatasetAsImage.vue?vue&type=template&id=3029b3d8&"
import script from "./HistoryDatasetAsImage.vue?vue&type=script&lang=js&"
export * from "./HistoryDatasetAsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports